interface StatusBadgeProps {
  status: string;
}

function getStatusClasses(status: string): string {
  switch (status.toLowerCase()) {
    case 'running':
    case 'replicating':
      return 'bg-green-500/20 text-green-400';
    case 'failed':
    case 'error':
      return 'bg-red-500/20 text-red-400';
    case 'paused':
      return 'bg-amber-500/20 text-amber-400';
    case 'stopped':
      return 'bg-gray-500/20 text-gray-400';
    case 'starting':
      return 'bg-blue-500/20 text-blue-400';
    default:
      return 'bg-gray-500/20 text-gray-400';
  }
}

function capitalize(str: string): string {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const colorClasses = getStatusClasses(status);

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClasses}`}
    >
      {capitalize(status)}
    </span>
  );
}
